/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable,TableHead} from 'components/data-table'
import {downloadFile} from 'stores/files'
import {DropdownCalendar, DropdownCheckgroup} from 'components/filters'

export default {
  components: {
    DataTable,
    Column,
    DropdownCheckgroup,
    DropdownCalendar,
    TableHead
  },
  props: {
    count: {type: Number, default: 0},
    loading: {type: Boolean, default: false},
    files: {type: Array, default: () => []},
    allExts: {type: Array, default: () => []},
    skip: {type: Number, default: 0},
    highlight: {type: String, default: ''},
  },
  emits: ['select', 'delete', 'upload', 'update'],
  data: function() {
    return {
      selected: new Set(),
      //
      // Filters
      //
      filter_exts: [],
      filter_dates: [],
      //
      // Sorting
      //
      sort_field: 'created_at',
      sort_order: 1
    }
  },
  computed: {
    all_selected() {
      return this.selected.size === this.files.length
    },
    can_clear(){
      return this.filter_exts.length || this.filter_dates?.length
    },
  },
  watch: {
    filter_exts(){
      this.onFilters({ext: this.filter_exts.join(',').toLowerCase()})
    },
    filter_dates(){
      let period
      if (this.filter_dates.length === 2) {
        const range = $utils.format.normalizeDateRange(this.filter_dates)
        period = range.join(',')
      }
      this.onFilters({period})
    },
    'files': {
      handler(){
        const selected = [...this.selected]
        selected.forEach(id => {
          if (!this.files.find(file => file.id === id)) this.selected.delete(id)
        })
      },
      deep: true
    },
  },
  methods: {
    async onPage(ev){
      this.$emit('update', {skip: ev.first, limit: ev.rows})
    },
    async onSearch(name){
      this.$emit('update', {name, skip: 0})
    },
    async onFilters(ev){
      this.$emit('update', {...ev, skip: 0})
    },
    onSort(ev){
      this.sort_field = ev.sortField
      this.sort_order = ev.sortOrder
      this.$emit('update', {sort: `${this.sort_field}:${this.sort_order === 1 ? 'asc' : 'desc'}`})
    },
    async onDownload(file_id) {
      await downloadFile(file_id)
    },
    async onDelete(file_id) {
      this.$emit('delete', [file_id])
    },
    async onDeleteSelected() {
      this.$emit('delete', [...this.selected])
    },
    onToggleSelected(id) {
      this.selected.has(id) ? this.selected.delete(id) : this.selected.add(id)
    },
    onToggleHead() {
      if (this.selected.size > 0) this.selected = new Set()
      else this.selected = new Set(this.files.filter(file => !file.processing).map(file => file.id))
    },
    async clearFilters(){
      this.filter_exts = []
      this.filter_dates = []
      this.onFilters({
        ext: null,
        period: null
      })
    },
    onReset(){
      if (this.highlight) this.$refs.search.clearSearch()
      if (this.can_clear) this.clearFilters()
    }
  },
}
